import { Stack, Text } from "@mantine/core"
import { Missing } from "@tfg/ui"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { CopyToClipboard } from "~/components/CopyToClipboard"
import { CountryCell } from "~/components/cells/CountryCell"

type Props = {
  directSupplier?: LibraryResponses.Product["directSupplier"]
}

export const SupplierCell = ({ directSupplier }: Props) => {
  return directSupplier ? (
    <Stack gap={0}>
      <Stack gap={0} align="left">
        <CopyToClipboard
          text={directSupplier.email}
          style={{ cursor: "pointer", textDecoration: "underline" }}
        />
      </Stack>
      <Stack gap={0} fz="xs" c="var(--mantine-color-gray-6">
        <Text fz="xs">{directSupplier.company?.name}</Text>
        <CountryCell countryIso3166={directSupplier.company?.country} />
      </Stack>
    </Stack>
  ) : (
    <Missing />
  )
}
